import "./_randomColorGenerator.scss";
import { useEffect, useState, useCallback } from "react";
import data from "./rcg-data";
import Rendering from "../RenderingComponent/Rendering";

export default function RandomColorGenerator() {

  const [colorType, setColorType] = useState('hex');
  const [color, setColor] = useState('#232323');

  function handleColorType(color) {
    setColorType(color);

  }
  const randomColor = useCallback(() => {
    const hexcode = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f'];
    if (colorType === 'hex') {
      let hex = '#';
      for (let i = 0; i <= 5; i++) {
        hex += hexcode[Math.floor(Math.random() * hexcode.length)];
      }
      setColor(hex);
    } else {
      const rgb = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
      setColor(rgb);
    }
  }, [colorType]);

  const renderingContent = (
    <>
      <p>Color: {color}</p>
      <button onClick={() => randomColor()}>Generate Color</button>
    </>
  )

  useEffect(() => {
    randomColor();
  }, [randomColor]);

  const renderingButtons = (
    <>
      <button
        onClick={() => handleColorType("hex")}
        className={colorType === "hex" ? "active" : null}
      >
        HEX
      </button>
      <button
        onClick={() => handleColorType("rgb")}
        className={colorType === "rgb" ? "active" : null}
      >
        RGB
      </button>
    </>)
  return (
    <Rendering data={data} renderingComponent={renderingContent} activeType={colorType} buttons={renderingButtons} className={"random-color-generator"} bgColor={color} />
  )
}
